import React, { useState, useEffect } from "react";
import { Form, Col } from "react-bootstrap";
import { withCookies } from "react-cookie";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState } from "draft-js";
import { useTranslation } from "react-i18next";
import configVars from "../../config";

const { createSliderWithTooltip } = Slider;
const SliderWT = createSliderWithTooltip(Slider);
const wrapperStyle = { width: "100%" };

const IdeaBank = ({ selectedTask }) => {
  const [translation] = useTranslation("translations");
  const [title, setTitle] = useState({
    value: "",
    error: false,
  });
  const [factors, setFactors] = useState("");
  const [investments, setInvestments] = useState(null);
  const [idea, setIdea] = useState(null);
  const [effects, setEffects] = useState(null);
  const priority =
    selectedTask && parseInt(selectedTask.priority)
      ? parseInt(selectedTask.priority)
      : 0;

  useEffect(() => {
    if (selectedTask) {
      setTitle({ value: selectedTask.title, error: false });

      let _factorDesc = null;
      if (selectedTask?.idea_bank_factor_description) {
        _factorDesc = selectedTask?.idea_bank_factor_description;
      } else if (selectedTask?.current_situation_factor_description) {
        _factorDesc = selectedTask?.current_situation_factor_description;
      } else if (selectedTask?.action_plan_factor_description) {
        _factorDesc = selectedTask?.action_plan_factor_description;
      }

      if (_factorDesc) {
        const contentBlock1 = htmlToDraft(_factorDesc);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setFactors(editorState);
        }
      }

      let _idea = null;
      if (selectedTask?.action_plan_decided_action) {
        _idea = selectedTask?.action_plan_decided_action;
      } else if (selectedTask?.idea_for_change_description) {
        _idea = selectedTask?.idea_for_change_description;
      } else if (selectedTask?.implementation_decided_action) {
        _idea = selectedTask?.implementation_decided_action;
      } else if (selectedTask?.evaluation_result) {
        _idea = selectedTask?.evaluation_result;
      }

      if (_idea) {
        const contentBlock2 = htmlToDraft(_idea);
        if (contentBlock2) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock2.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setIdea(editorState);
        }
      }
      let _investment = selectedTask?.investment_description;

      if (_investment) {
        const contentBlock2 = htmlToDraft(_investment);
        if (contentBlock2) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock2.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setInvestments(editorState);
        }
      }
      let _result = selectedTask?.result_description;

      if (_result) {
        const contentBlock2 = htmlToDraft(_result);
        if (contentBlock2) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock2.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setEffects(editorState);
        }
      }
    }
  }, [selectedTask]);

  return (
    <Form>
      <div className="">
        <Col className="">
          <div className="d-lg-flex flex-lg-column title-content">
            <Form.Group className="mb-3">
              <Form.Label>
                <b>{translation("task_forms.idea_bank.field1.label")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={translation(
                  "task_forms.idea_bank.field1.placeholder"
                )}
                value={title?.value}
                disabled
                isInvalid={title?.error}
                style={{
                  fontSize: "14px",
                  padding: "0.5rem 0.5rem",
                  borderRadius: "0px",
                }}
              />
              {title?.error && (
                <Form.Control.Feedback type="invalid">
                  {translation("task_forms.idea_bank.field1.error")}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </div>
        </Col>
        <Col className="">
          <div className="d-flex justify-content-center mb-4 ">
            <div style={wrapperStyle}>
              <p><b>{translation("task_forms.idea_bank.field2.label")}</b></p>
              <div className="px-2" >
                <SliderWT
                  min={0}
                  max={10}
                  defaultValue={priority}
                  marks={{ 0: 0, 3: 3, 5: 5, 7: 7, 10: 10 }}
                  step={null}
                  disabled
                  tipFormatter={(value) => {
                    switch (value) {
                      case 0:
                        return (
                          <div style={{ width: "70px" }}>
                            {translation("task_forms.idea_bank.field2.0")}
                          </div>
                        );
                      case 3:
                        return (
                          <div style={{ width: "70px" }}>
                            {" "}
                            {translation("task_forms.idea_bank.field2.1")}
                          </div>
                        );
                      case 5:
                        return (
                          <div style={{ width: "70px" }}>
                            {" "}
                            {translation("task_forms.idea_bank.field2.2")}
                          </div>
                        );

                      case 7:
                        return (
                          <div style={{ width: "70px" }}>
                            {" "}
                            {translation("task_forms.idea_bank.field2.3")}
                          </div>
                        );
                      case 10:
                        return (
                          <div style={{ width: "70px" }}>
                            {" "}
                            {translation("task_forms.idea_bank.field2.4")}
                          </div>
                        );
                      default:
                        return "";
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </Col>
      </div>

      <Form.Group className="mb-3">
        <Form.Label>
          <b> {translation("task_forms.idea_bank.field3.label")}</b>
        </Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          editorState={factors}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>
          <b>{translation("task_forms.idea_bank.field4.label")}</b>
        </Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          editorState={idea}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>
          <b>{translation("task_forms.idea_bank.field5.label")}</b>
        </Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          editorState={investments}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>
          <b>{translation("task_forms.idea_bank.field6.label")}</b>
        </Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          editorState={effects}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
    </Form>
  );
};

export default withCookies(IdeaBank);
